// extracted by mini-css-extract-plugin
export default {"opaque":"mAFjNdOUn8pCx2Iddqez","menu":"ykNWhJ8eSBnUiakwo7p9","menuitem":"_rBzW503cN0YdlsqfCuG","shopPill":"wlAGw21ALq5mtzVphDy5","placeHolderShimmer":"geZ1Y9r4pSinCC1dHxWT"};